import { useState } from 'react';
import { Trade } from '../types/Trade';

const STORAGE_KEY = 'dashboard_trades';

function loadTrades(): Trade[] {
  const raw = localStorage.getItem(STORAGE_KEY);
  return raw ? JSON.parse(raw) : [];
}

function saveTrades(trades: Trade[]) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(trades));
}

export function useTrades() {
  const [trades, setTrades] = useState<Trade[]>(loadTrades);

  const addTrade = (trade: Omit<Trade, 'id' | 'createdAt' | 'updatedAt'>) => {
    const now = new Date().toISOString();
    const newTrade: Trade = {
      ...trade,
      id: crypto.randomUUID(),
      createdAt: now,
      updatedAt: now,
    };
    const updated = [...trades, newTrade];
    setTrades(updated);
    saveTrades(updated);
  };

  const deleteTrade = (id: string) => {
    const updated = trades.filter((t) => t.id !== id);
    setTrades(updated);
    saveTrades(updated);
  };

  const editTrade = (id: string, changes: Partial<Trade>) => {
    const updated = trades.map((t) =>
      t.id === id
        ? { ...t, ...changes, updatedAt: new Date().toISOString() }
        : t,
    );
    setTrades(updated);
    saveTrades(updated);
  };

  return { trades, addTrade, deleteTrade, editTrade };
}
